export default "__VITE_ASSET__4b29cbfe__"